import env from "../../utils/env";

const AnalyticsService = function (HttpService) {
    "ngInject"

    const getRevenueDataSource = (successCb) => {
        const dataSource = new kendo.data.DataSource({
            transport: {
                read: {
                    url: env.getApiUrl("analytics/revenue"),
                    contentType: "application/json",
                    type: "GET",
                    beforeSend: _onBeforeSend,

                },
                // parameterMap: _parameterMap
            },
            change: successCb,
            schema: {
                data: (response) => response.series[0].data,
                model: {
                    id: "id",
                    fields: {
                        "date": { type: "date" },
                        "revenue": {},
                    }
                }
            },
        })

        return dataSource;
    }

    // const getRevenueData = (successCb, failureCb) => {
    //     HttpService.get("analytics/revenue", successCb, failureCb);
    // }

    // const getPayingCustomersData = (successCb, failureCb) => {
    //     HttpService.get("analytics/payingcustomers", successCb, failureCb);
    // }

    // const getJobsSuccessRateData = (successCb, failureCb) => {
    //     HttpService.get("analytics/jobssuccessrate", successCb, failureCb);
    // }

    const getRevenueData = () => {
        return HttpService.getPromise("analytics/revenue");
    }

    const getMonthlyRevenueData = () => {
        return HttpService.getPromise("analytics/nmrrevenue");
    }

    const getRevenueYearOverYearData = () => {
        return HttpService.getPromise("analytics/revenueyoy");
    }

    const getRevenueFinancialYearOverYearData = () => {
        return HttpService.getPromise("analytics/revenuefyoy");
    }

    const getRevenueFinancialYearOverYearBreakdownData = () => {
        return HttpService.getPromise("analytics/revenuefyoybreakdown");
    }

    const getRevenueBreakdownData = () => {
        return HttpService.getPromise("analytics/revenuebreakdown");
    }

    const getBusinessRevenueBreakdownData = () => {
        return HttpService.getPromise("analytics/businessrevenuebreakdown");
    }

    const getHelperRevenueBreakdownData = () => {
        return HttpService.getPromise("analytics/helperrevenuebreakdown");
    }

    const getNewRevenueBreakdownData = () => {
        return HttpService.getPromise("analytics/newrevenuebreakdown");
    }

    const getAccountRatingsBreakdownData = () => {
        return HttpService.getPromise("analytics/accountratingsovertime");
    }

    const getRevenueByStateData = () => {
        return HttpService.getPromise("analytics/revenuebystate");
    }

    const getNzRevenueByRegionData = () => {
        return HttpService.getPromise("analytics/nzrevenuebyregion");
    }

    const getPayingCustomersOvertimeData = () => {
        return HttpService.getPromise("analytics/payingcustomersovertime");
    }

    const getUpsellBreakdown = () => {
        return HttpService.getPromise("analytics/upsellBreakdown");
    }

    const getAvgTrnValueData = () => {
        return HttpService.getPromise("analytics/avgtrnvalue");
    }

    const getRefundsData = () => {
        return HttpService.getPromise("analytics/refunds");
    }

    const getRefundsAmountData = () => {
        return HttpService.getPromise("analytics/refundscount");
    }

    const getClientRefundsData = () => {
        return HttpService.getPromise("analytics/clientrefunds");
    }

    const getRecentRevenueData = () => {
        return HttpService.getPromise("analytics/recentrevenue");
    }

    const getRecentRevenueByDeviceData = () => {
        return HttpService.getPromise("analytics/recentrevenuebydevice");
    }

    const getRevenueByDeviceData = () => {
        return HttpService.getPromise("analytics/revenuebydevice");
    }

    const getDataSets = () => {
        return HttpService.getPromise("analytics/datasets");
    }

    const getJobValueOverTimeData =() => {
        return HttpService.getPromise("analytics/jobsvalueovertime");
    }

    const getJobValueByFinancialYearData =() => {
        return HttpService.getPromise("analytics/jobsvaluebyfinancialyear");
    }

    const getPayingCustomersData = () => {
        return HttpService.getPromise("analytics/payingcustomers");
    }

    const getCustomerRedemptionsOverTime = () => {
        return HttpService.getPromise("analytics/customerredemptionsovertime");
    }

    const getRegistrationsOverTimeData = () => {
        return HttpService.getPromise("analytics/registrationsovertime");
    }

    const getRegistrationsYearOverYearData = () => {
        return HttpService.getPromise("analytics/registrationsyoy");
    }

    const getRegistrationsFinancialYearOverYearData = () => {
        return HttpService.getPromise("analytics/registrationsfyoy");
    }

    const getNSWRegistrationsByRegionOverTimeData = () => {
        return HttpService.getPromise("analytics/nswregistrationsbyregionovertime");
    }

    const getNZRegistrationsByRegionOverTimeData = () => {
        return HttpService.getPromise("analytics/nzregistrationsbyregionovertime");
    }

    const getVICRegistrationsByRegionOverTimeData = () => {
        return HttpService.getPromise("analytics/vicregistrationsbyregionovertime");
    }

    const getQLDRegistrationsByRegionOverTimeData = () => {
        return HttpService.getPromise("analytics/qldregistrationsbyregionovertime");
    }

    const getRecentRegistrationsData = () => {
        return HttpService.getPromise("analytics/recentregistrations");
    }

    const getRecentAppDownloadsData = () => {
        return HttpService.getPromise("analytics/recentappdownloads");
    };

    const getTopRegistrationsData = () => {
        return HttpService.getPromise("analytics/topregistrations");
    }

    const getTopRevenueData = () => {
        return HttpService.getPromise("analytics/toprevenue");
    }

    const getRegistrationsByStateData = () => {
        return HttpService.getPromise("analytics/registrationsbystate");
    }

    const getRecentNSWRegistrationsData = () => {
        return HttpService.getPromise("analytics/recentnswregistrations");
    }

    const getRecentVICRegistrationsData = () => {
        return HttpService.getPromise("analytics/recentvicregistrations");
    }

    const getRecentQLDRegistrationsData = () => {
        return HttpService.getPromise("analytics/recentqldregistrations");
    }

    const getJobsSuccessRateData = () => {
        return HttpService.getPromise("analytics/jobssuccessrate");
    }

    const getAccountApprovalOverTime = () => {
        return HttpService.getPromise("analytics/accountapprovalovertime");
    }

    const getNewVersusRecurringRevenueData = () => {
        return HttpService.getPromise("analytics/newvsrecurringrevenue");
    }

    const getHelperNewVersusRecurringRevenueData = () => {
        return HttpService.getPromise("analytics/helpernewvsrecurringrevenue");
    }

    const getGeneralStatsData = () => {
        return HttpService.getPromise("analytics/generalstats");
    }

    const getBotStatsData = () => {
        return HttpService.getPromise("analytics/botstats");
    }

    const getClientProfileItemsPerYearData = () => {
        return HttpService.getPromise("analytics/clientprofileitemsperyear");
    }

    const getProviderProfileItemsPerYearData = () => {
        return HttpService.getPromise("analytics/providerprofileitemsperyear");
    }

    const getMonthlyActiveUsersData = () => {
        return HttpService.getPromise("analytics/monthlyactiveusers");
    };

    const getArruData = () => {
        return HttpService.getPromise("analytics/arpu");
    };

    const formatRevenueData = (data) => {
        let revenueData = [];
        let categories = [];
        let seriesArr = data.series;

        seriesArr.map((item, index) => {

            if (categories.length == 0) {
                item.data.map((categoryItem) => {
                    categories.push(categoryItem.data);
                })
            }

            revenueData[index] = {
                name: item.name,
                data: item.data,
                field: "revenue",
                // categoryField: "date",
                // labels: {
                //     visible: true,
                //     format: "{0:C}"
                // },
                tooltip: {
                    visible: true,
                    background: "#60686e",
                    format: "{0:C}"
                },
            };
        });

        return {
            series: [revenueData[0]],
            categoryAxis: {
                categories: categories,
                title: {
                    text: "Weeks",
                },
                labels: {
                    format: "MMM"
                },
                baseUnit: "weeks",
                field: "date"
            },
        };
    }

    const getColumnChartOptions = (title, data) => {
        return {
            title: {
                text: title
            },
            theme: "silver",
            legend: {
                position: "top"
            },
            seriesDefaults: {
                type: "column"
            },
            series: data.series,
            valueAxis: {
                labels: {
                    format: "{0:p0}"
                },
                line: {
                    visible: false
                },
                axisCrossingValue: 0,
                max: 1
            },
            categoryAxis: {
                categories: data.categories,
                labels: {
                    template: "#= kendo.toString(new Date(value), 'yyyy') #",
                },
                line: {
                    visible: false
                },
            },
            tooltip: {
                visible: true,
                format: "{0}%",
                template: "#= series.name #: #= kendo.toString(value, 'p') #"
            }
        };
    }

  const getFunnelChartOptions = (title, data, percentageTemplate) => {
    return {
      title: {
            text: title,
            position: "bottom"
        },
        theme: "silver",
        legend: {
            visible: false,
            position: "bottom"
        },
        seriesDefaults: {
            labels: {
                visible: true,
                background: "transparent",
                position: "center",
                template: "#= category #",
                //color:"white",
                //format: "N0"
            },
            dynamicSlope: false,
            dynamicHeight: false
        },
        series: [{
            type: "funnel",
            data: data
        }],
        tooltip: {
            visible: true,
            template: percentageTemplate
        }
    };
  }

  const getDonutChartOptions = (set, titleFormat, labelFormat) => {
    return {
      title: {
            text: titleFormat,
            position: "bottom"
        },
        theme: "silver",
        legend: {
            visible: false,
            position: "bottom"
        },
        seriesDefaults: {
            startAngle: 150,
            labels: {
              visible: true,
              background: "transparent",
              position: "outsideEnd",
              template: labelFormat
            },
        },
        series: [{
            type: "donut",
            field: "percentage",
            categoryField: "category",
            data: set.data
        }],
        tooltip: {
            visible: false,
        }
    };
  }

  const getPercentage = (entry) => {
    let dataItem = entry.dataItem;
    if (entry.index > 0) {
      let prevDataItem = entry.series.data[entry.index - 1];
      return kendo.format("{0:P} of '{1}' become '{2}', {3:P} of Total Accounts",
        dataItem.percentage, prevDataItem.category, dataItem.category, dataItem.percentageFromTotal);
    } else {
      return kendo.format("{0:P} of Total Accounts", dataItem.percentage);
    }
  }

  const getGridOptions = (set)=> {
    let data = set.data;
    let columns = set.dataInfo;
    columns[0].width = "250px";

    return {
      dataSource: {
          data: data,
          pageable: false
      },
      columns: columns,
      scrollable: false,
      sortable: false,
      filterable: false,
    }
  }

  const getChartOptions = (title, series, categories, format, template, dateFormat, tooltipTemplate, categoryBaseUnit) => {
    let tooltipFormatter;
    if (typeof tooltipTemplate == "function") {
        tooltipFormatter = tooltipTemplate;
    } else {
        if (!tooltipTemplate)
            tooltipTemplate = "n0";

        tooltipFormatter = (args) => {
            const date = kendo.toString(new Date(args.category), dateFormat && dateFormat.days ? dateFormat.days : "MMM yyyy");
            return date + ' - ' + kendo.toString(args.value, tooltipTemplate);
        }
    }

    return {
      title: {
        text: title,
      },
      theme: "silver",
      seriesDefaults: {
        type: "line",
        labels: {
          visible: true,
          format: format,
        }
      },
      series: series,
      legend: {
        position: "bottom",
        labels: {
          template: template
        }
      },
      tooltip: {
        visible: true,
        background: "#60686e",
        format: format,
        template: tooltipFormatter,
      },
      valueAxis: {
        labels: {
          format: format
        }
      },
      categoryAxis: {
        type: "date",
        categories: categories,
        baseUnit: categoryBaseUnit,
        labels: {
          visible: true,
          dateFormats: dateFormat,
        }
      }
    };
  }

    return { getRevenueDataSource, getRevenueBreakdownData, getNewRevenueBreakdownData, getRefundsData, getRefundsAmountData, getClientRefundsData, getPayingCustomersData, getRevenueData, getRecentRevenueData, getRecentRevenueByDeviceData,
        getRevenueByDeviceData, formatRevenueData, getJobsSuccessRateData, getRegistrationsOverTimeData, getNSWRegistrationsByRegionOverTimeData, getVICRegistrationsByRegionOverTimeData, getNZRegistrationsByRegionOverTimeData, getUpsellBreakdown,
        getRecentRegistrationsData, getRecentNSWRegistrationsData, getRecentVICRegistrationsData, getRecentQLDRegistrationsData, getCustomerRedemptionsOverTime, getRegistrationsYearOverYearData, getRegistrationsFinancialYearOverYearData,
        getAccountApprovalOverTime, getNewVersusRecurringRevenueData, getGeneralStatsData, getBotStatsData, getRevenueYearOverYearData, getRevenueFinancialYearOverYearData, getQLDRegistrationsByRegionOverTimeData, getRevenueByStateData, getNzRevenueByRegionData,
        getClientProfileItemsPerYearData, getProviderProfileItemsPerYearData, getJobValueOverTimeData, getDataSets, getRegistrationsByStateData, getAvgTrnValueData, getPayingCustomersOvertimeData, getRevenueFinancialYearOverYearBreakdownData,
        getColumnChartOptions, getFunnelChartOptions, getDonutChartOptions, getGridOptions, getPercentage, getChartOptions, getTopRegistrationsData, getTopRevenueData, getMonthlyRevenueData, getHelperRevenueBreakdownData,
        getMonthlyActiveUsersData, getArruData,getJobValueByFinancialYearData, getRecentAppDownloadsData, getAccountRatingsBreakdownData, getHelperNewVersusRecurringRevenueData, getBusinessRevenueBreakdownData,
    };
};

function _onBeforeSend(req) {
    var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;

    req.setRequestHeader("Authorization", token);
}

export default AnalyticsService;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/analytics.service.js
 **/